import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import Swipeable from 'react-swipeable'
import appRoutes from '../../routes.js';
import {AppContext} from "../../AppContext";

class Sidebar extends Component {

  constructor(props) {
    super(props);
    this.onSwipedRight = this.onSwipedRight.bind(this);
  }

  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? 'active' : '';
  }

  onSwipedRight(e, deltaX) {
    if (deltaX > 50 || deltaX < 50) {
      this.props.closeSidebar();
    }
  }

  render() {
    return (
      <Swipeable onSwipedRight={this.onSwipedRight}>
        <div id="sidebar" className="sidebar">
          <div className="sidebar-wrapper">
            <ul className="nav">
              {
                appRoutes.map((prop, key) => {
                  if (!prop.redirect) {
                    return (
                      <li className={prop.upgrade ? "active active-pro" : this.activeRoute(prop.path)} key={key}>
                        <NavLink to={prop.path} className="nav-link" activeClassName="active">
                          <i className={prop.icon}></i>
                          <p>{prop.name}</p>
                        </NavLink>
                      </li>
                    );
                  }
                  return null;
                })
              }
            </ul>
          </div>
        </div>
      </Swipeable>
    );
  }
}

export default props => (
  <AppContext.Consumer>
    { ctx => <Sidebar {...props} closeSidebar={ctx.closeSidebar} /> }
  </AppContext.Consumer>
);
